import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "OPT-IN_EMAIL",
	"data-name": "OPT-IN EMAIL",
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			rx: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			x2: 7.424,
			y2: 5.939,
			transform: "translate(5.864 18.485)",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: 14.847,
			x2: 14.847,
			transform: "translate(13.288 9.576)",
			fill: "none",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 2
		})
	]
});
export default SvgCheckboxChecked;
